import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import ApiService from "@/shared/api/BaseApiService";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Alert } from "@mui/material";
import { LoginLayout } from "../structure/LoginLayout";
import { setToken } from "@/shared/api/request";

const BaseLogin = ({
  setAuthenticated = undefined,
  setAuthenticatedWithUser = undefined,
  image,
  checkAccessRights = (_) => true,
}: {
  setAuthenticated?: (state: boolean) => void;
  setAuthenticatedWithUser?: (
    state: boolean,
    user: number,
    password?: string,
  ) => void;
  image: string;
  checkAccessRights?: (rights: { [right: string]: any }) => boolean;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation({
    mutationFn: ApiService.loginCheck,
    onSuccess: (answer) => {
      let rawRights = Array.isArray(answer?.rights ?? "{}")
        ? "{}"
        : (answer?.rights ?? "{}");
      if (typeof rawRights !== "string") rawRights = JSON.stringify(rawRights);
      if (!checkAccessRights(JSON.parse(rawRights)))
        throw new Error("Access control failure");
      setToken(answer.token, answer.refresh_token, rawRights);
      if (!!setAuthenticatedWithUser)
        setAuthenticatedWithUser(true, answer?.user?.id ?? 0, password);
      else if (!!setAuthenticated) {
        setAuthenticated(true);
      }
    },
    onError: (error) => {
      console.log("error", error);
    },
  });

  return (
    <LoginLayout
      image={image}
      showLegal={import.meta.env.VITE_SHOW_LEGAL !== "no"}
    >
      <Box
        component="form"
        sx={{ mt: 1 }}
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate({ email, password });
        }}
      >
        {login.isError ? (
          <Alert severity="error">Fehler beim Anmelden.</Alert>
        ) : null}
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="E-Mail"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail((e.target as HTMLInputElement).value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          value={password}
          onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
          label="Passwort"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <LoadingButton
          loading={login.isLoading}
          fullWidth
          type="submit"
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Anmelden
        </LoadingButton>
      </Box>
    </LoginLayout>
  );
};

export default BaseLogin;
